<template>
<div>
    <Modal
        :value="setAdminModel"
        :title="$t('changepwd')+' '+name"
        :footer-hide="true"
        :mask-closable="false"
        @on-cancel="cancel"
        :z-index='1026'
        :styles="{'margin-top': '200px'}"
        >
            <Form ref="formData" :model="formData" :rules="ruleCustom" :label-width="80">
                <!-- <Tabs type="card"  v-model="tabIndex">
                <TabPane label="修改密码" name="1">
                   
                </TabPane>
                 </Tabs> -->
                  <FormItem :label="$t('topCon.CurrentPassword')" prop="password" >
                        <Input  v-model.trim="formData.password"  :placeholder="$t('inputPlaceholder')"></Input>
                    </FormItem>
                    <FormItem :label="$t('topCon.NewPassword')" prop="newPassword">
                        <Input  v-model.trim="formData.newPassword" :placeholder="$t('inputPlaceholder')"></Input>
                    </FormItem>
                    <FormItem :label="$t('topCon.NewPassword1')" prop="newPasswordConfirm">
                        <Input v-model.trim="formData.newPasswordConfirm" :placeholder="$t('inputPlaceholder')"></Input>
                    </FormItem>
                 <FormItem>
                    <Button :loading="disabled" type="primary" @click="subData('formData')">{{$t('confirm')}}</Button>
                </FormItem>
            </Form>
    </Modal>
</div>
</template>
<script>
/**
 * 弹框
 * @param dataRow  Object  点击的单条数据
 * @param setAdminModel boolean 对话框开关 true false  退款状态
 * @param fn function 回调函数
 */
import common from '@/common/common.js';
import moment from 'moment';
import { mapState } from 'vuex'

    export default {
        props:{
            row: Object, // 当前点击的 那条数据 （对象）
            setAdminModel: Boolean,
            fn:Function,
            dataRow: Object,
            name:[Number, String]
        },
        components: {
        },
        name: "Modelamdin",
        data () {
            // var pwds = function(rule, value, callback){
            //     var reg = /^[0-9a-zA-Z]{6,10}$/;
            //     if(value != ''){
            //         if(!value){
            //             return callback(new Error(this.$t('formRules.fmtPassword')));
            //         } else if (reg.test(value)==false) {             
            //             return callback(new Error(this.$t('formRules.fmtPassword')));                   
            //         }
            //         else{
            //             callback();
            //         }
            //     }else{
            //         callback();
            //     } 
            // };
            return {
                disabled:false,//禁用确定按钮
                tabIndex:"1", //标签显示页
                addBox:{//弹框组
                    adtype:0
                },
                formData: {//表单数据
                    password:"",
                    newPassword:"",
                    newPasswordConfirm:"",
                }
            }
        },
        computed:{
            ...mapState(['local','selectId','uInfo']),
            ruleCustom(){
                return  {//验证
                    password:[
                         {required: true, message: this.$t('required'), trigger:'blur' },
                         { type: 'string', pattern: /^[0-9a-zA-Z]{6,10}$/, message: this.$t('ruleCustom.pwd'), trigger:'blur'},
                    ],
                    newPassword:[
                         {required: true, message: this.$t('required'), trigger:'blur' },
                         { type: 'string', pattern: /^[0-9a-zA-Z]{6,10}$/, message: this.$t('ruleCustom.pwd'), trigger:'blur'},
                    ],
                    newPasswordConfirm:[
                         {required: true, message: this.$t('required'), trigger:'blur' },
                         { type: 'string', pattern: /^[0-9a-zA-Z]{6,10}$/, message: this.$t('ruleCustom.pwd'), trigger:'blur'},
                    ], 
                }
            }

        },
        watch:{  
            dataRow (newValue) {
            },
                
        },
        created(){
           
        },
        methods: {
            subData (name) {//提交表单
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        this.disabled = true;
                        if(this.formData.newPassword != '' && this.formData.newPasswordConfirm != ''){{
                            if(this.formData.newPassword != this.formData.newPasswordConfirm){
                            common.msg('error',this.$t('formRules.twoPassword_notMatch'),()=>{this.disabled = false;})
                            return false
                            }
                        }}
                        this.axios.post(this.config.urlArray.usersPassword,{...this.formData,id:this.selectId}).then((result) => {
                            // console.log(result)
                            if(result.data.code == 1){
                                common.msg('success',result.data.data,()=>{
                                    this.disabled = false
                                })
                                if(this.selectId==this.uInfo.id){
                                    window.sessionStorage.clear(); //清空缓存
                                    window.localStorage.clear(); //清空缓存
                                    this.$store.commit('setTabMenuList',[{activeId: "0-1",fId: 0,fTitle: "平台首页",name: "平台首页",routeName: "home",routerUrl: "/"}])
                                    this.$store.commit('setTabMenuItem',{activeId: "0-1",fId: 0,fTitle: "平台首页",name: "平台首页",routeName: "home",routerUrl: "/"})
                                    document.cookie = "userPwd=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
                                    document.cookie = "Authorization=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
                                    
                                    this.resetForm()
                                    // this.fn()
                                    setTimeout(() => {
                                        this.$router.push({ name: 'login' })
                                    }, 1500);

                                }else{
                                    this.resetForm()
                                }
                                
                            }else{
                                this.disabled = false
                                common.msg('error',result.data.message,()=>{this.disabled = false;})
                            }
                            
                        }).catch((err) => {
                             this.disabled = false
                            // console.log('err',err)
                            // common.msg('error',err,()=>{this.disabled = false;})
                        });
                    }
                })
            },
            cancel () {//对话框关闭
                this.$emit('update:setAdminModel',false)
            },
            resetForm () {//重置表单
                this.$refs.formData.resetFields();//重置表单
                this.tabIndex = '1' // 重置标签页
                this.disabled = false;//恢复提交按钮为激活状态
                this.addBox.adtype = 0
                this.cancel()
            }
           
        }
    }
</script>
<style lang="less" scoped>
.ivu-form .ivu-form-item-label{
    width:120px ;
    text-align: center !important;
    text-indent: 1px;
  }
  .ivu-form-item-content{
    margin-left: 120px !important;
  }

  .ivu-form-item{
      margin-bottom: 35px;
  }
</style>
